module.exports = __webpack_public_path__ + "img/mistweaver.20431403.jpg";